module.exports = __webpack_public_path__ + "static/media/Mais.ff3d48ed.svg";